module.exports = __webpack_public_path__ + "bc550c98147da8180e3c006a1b26a604.svg";